import { CustomPageHeader, Text } from '@src/components';
import OrderList from './OrderList';
import { useEffect } from 'react';
import { orderGetPageList } from '@src/store/slice/orderSlice';
import { useDispatch } from 'react-redux';
import { useLang } from '@src/context';

const MyOrders = () => {
  const dispatch = useDispatch();
  const { language } = useLang();

  useEffect(() => {
    (async () => {
      await dispatch(
        orderGetPageList({ body: { vouId: 1, orderCancel: false }, pageNumber: 1, pageSize: 10 }),
      );
    })();

    window.scrollTo(0, 0);
  }, [dispatch, language]);

  return (
    <CustomPageHeader
      data-testid="my-orders"
      title={<Text t="myOrders" />}
      showBreadCrumb
      showHelpButton
      routes={['ticketRestaurantHeader']}
    >
      <OrderList />
    </CustomPageHeader>
  );
};

export default MyOrders;
